module.exports = __webpack_public_path__ + "static/media/buy-sell.02f829a2.jpg";